<div class="text-center d-flex flex-column p-5 ">
    <img
			src="assets/svg/x.svg"
			alt=""
			class="close-button"
			(click)="close()"
            width="14px"
            height="14px"
		/>
    <h1 class="space-top">¿Estas seguro de realizar una <br>
        nota de crédito?</h1>
    
    <p class="card-paragraph space-top">fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum.</p>

    <div class="d-flex  mx-auto gap-4 space-top">
        <button class="btn btn-white" (click)="close()" style="cursor: pointer;">Cancelar</button>
        <button class="btn btn-dark btn-block" (click)="open()">Aceptar</button>
    </div>
</div>